import { CommonHttpOption } from "./../../base/common-http-option";
import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { ServiceRoute } from "../../base/service-route";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class MajorDegreeService {
  constructor(private coreService: CoreService) {}

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.majorDegree.majorList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  degreeList(id: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.majorDegree.degreeList + id + "&xMajor=true",
      new CommonHttpOption().headers
    );
  }
}
